// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

/**
 * Override this handler to let PopulateApiParameter accept more props
 * And to pase customProduct/Event State of the variant children once they loaded
 */
import { addToChainAfter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    DispatchCompleteLoadProducts,
    PopulateApiParameter,
    RequestDataFromApi,
} from "@insite/client-framework/Store/Data/Products/Handlers/LoadVariantChildren";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import setCustomProductState from "@mcmc/App/Handlers/Pages/ProductDetails/SetCustomProductState";
import { parseProductCustomState } from "@mcmc/App/Handlers/Products/LoadProductByPath";
import McMcApplicationState from "@mcmc/App/Store/McMcApplicationState";
import { CustomProductState } from "@mcmc/App/Store/Reducers";
import { getIsEvent } from "@mcmc/App/Store/Selectors/ProductDetailsSelectors";

export const CustomPopulateApiParameter: typeof PopulateApiParameter = props => {
    props.apiParameter = {
        ...props.parameter,
        ...props.apiParameter,
    };
};

export const CustomDispatchCompleteLoadProducts: typeof DispatchCompleteLoadProducts = props => {
    if (!props.apiResult) {
        return;
    }

    const state = props.getState() as McMcApplicationState;
    const isEventParent = getIsEvent(state, { id: props.parameter.productId } as ProductModel);
    const customProductStates: CustomProductState[] = [];

    props.apiResult.products?.every(product => {
        customProductStates.push(parseProductCustomState(product, isEventParent));
        return true;
    });
    props.dispatch(setCustomProductState({ customProductStates }));

    return DispatchCompleteLoadProducts(props);
};

// MCMC-1834: Handling the variability loader for variant products by setting the value of customerUnitOfMeasure to be null if it's empty string
// TODO: Remove "XngRequestDataFromApi" method when do next upgrade, the insite solved the issue in v5.1.2202.464
export const XngRequestDataFromApi: typeof RequestDataFromApi = props => {
    const apiResult: any = { ...props.apiResult };
    apiResult.products = props.apiResult.products?.map(product => {
        const xProduct = { ...product } as any;
        xProduct.customerUnitOfMeasure = xProduct.customerUnitOfMeasure || null;
        return xProduct;
    });
    props.apiResult = apiResult;
};

addToChainAfter(chain, PopulateApiParameter, CustomPopulateApiParameter);

// TODO: Remove the next line when do next upgrade, the insite solved the issue in v5.1.2202.464
addToChainAfter(chain, RequestDataFromApi, XngRequestDataFromApi);

replaceInChain(chain, DispatchCompleteLoadProducts, CustomDispatchCompleteLoadProducts);
